/* eslint-disable camelcase */

import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listerClickThrough } from '../../../actions/lister-actions';
import { useIsXMediumAndAbove } from '../../../hooks/mediaQueries';
import { useIsProductInHighDemand } from '../../../hooks/useIsProductInHighDemand';
import Image from '../../Generic/Image/Image';
import './ProductImage.scss';

const GetImage = ({ src, ImageAltText, State, ColourId }) => {
	const isSkuHighDemand = useIsProductInHighDemand({ ColourId });

	const isXMediumAndAbove = useIsXMediumAndAbove();

	const imageDimension = isXMediumAndAbove ? '200px' : '100px';

	return (
		<Image
			src={src}
			alt={ImageAltText}
			classes={classnames('product-card__primary-image self-center', {
				'opacity-50': State === 'OutOfStock' || isSkuHighDemand,
			})}
			skeletonProps={{ height: imageDimension }}
			errorSize="large"
		/>
	);
};

const getSizeClasses = (customCategoriesEnabled, isNewAssetImage) => {
	return isNewAssetImage === false && customCategoriesEnabled
		? 'productImage__container'
		: 'productImage__scalable-container lg:max-w-xl max-w-sm flex';
};

const ProductImage = ({
	Gallery,
	Image: src,
	ImageAltText,
	FullProductUrl,
	Code,
	State,
	ColourId,
	classes,
}) => {
	const dispatch = useDispatch();

	const isXMediumAndAbove = useIsXMediumAndAbove();

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const styleProps = {
		minHeight: '1px',
		maxHeight: '200px',
		maxWidth: '200px',
	};

	const useNewAssetImage = Gallery?.MainImage?.Url != null;
	const imageSrcToUse = useNewAssetImage ? Gallery?.MainImage?.Url : src;

	if (isXMediumAndAbove && FullProductUrl) {
		return (
			<a
				href={FullProductUrl}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(FullProductUrl);

					dispatch(listerClickThrough(Code));
				}}
				className={classnames(
					'block m-auto',
					classes,
					getSizeClasses(CustomCategoriesEnabled, useNewAssetImage)
				)}
				style={CustomCategoriesEnabled ? {} : styleProps}
				itemProp="url"
				data-testid="product-image-link">
				<GetImage {...{ src: imageSrcToUse, ImageAltText, State, ColourId }} />
			</a>
		);
	}

	return (
		<div
			className={classnames(
				'block mx-auto my-4',
				getSizeClasses(CustomCategoriesEnabled, useNewAssetImage)
			)}
			style={CustomCategoriesEnabled ? {} : styleProps}
			itemProp="url"
			data-testid="product-image-link">
			<GetImage {...{ src: imageSrcToUse, ImageAltText, State, ColourId }} />
		</div>
	);
};

export default ProductImage;
